import { ServiceResponse } from "@sdbn/common";

export enum ParamterType {
    NONE = 'NONE', STRING = 'STRING', NUMBER = 'NUMBER'
}

export class SupplementaryEquipment {
    key: string;
    name: string;
    equipmentTypeId: string;
    selected: boolean;
    handouted = false;
    selectedIdentifier: string;
    availableIdentifiers: Array<string>;

    constructor(equipment?: any) {
        if (equipment != null) {
            this.key = equipment.key;
            this.equipmentTypeId = equipment.equipmentTypeId;
            this.selected = equipment.selected;
            this.handouted = equipment.handouted;
            this.name = equipment.name;
            this.selectedIdentifier = equipment.selectedIdentifier;
            this.availableIdentifiers = equipment.availableIdentifiers;
        }
    }
}

export class SupplementaryEquipmentResponse extends ServiceResponse {

    equipments: SupplementaryEquipment[];
}


export class TruckDetails {

    id: number;
    registration: string;
    leave: string;
    numberPlate: string;
    driver: string;
    coDriver: string;
    carrier: string;
    supplier: string;
    useGlobalConnect = false;
    usePager = false;
    serviceTruck: boolean;
    includedInTruckGroups: boolean;

    equipment = new Array<SupplementaryEquipment>();

    constructor(truck?: any) {
        if (truck != null) {
            this.id = truck.id;
            this.registration = truck.registration;
            this.leave = truck.leave;
            this.numberPlate = truck.numberPlate;
            this.driver = truck.driver;
            this.coDriver = truck.coDriver;
            this.carrier = truck.carrier;
            this.supplier = truck.supplier;
            this.useGlobalConnect = truck.useGlobalConnect;
            this.usePager = truck.usePager;
            this.serviceTruck = truck.serviceTruck;
            this.includedInTruckGroups = truck.includedInTruckGroups;
            if (truck.equipment != null) {
                for (const e of truck.equipment) {
                    this.equipment.push(new SupplementaryEquipment(e));
                }
            }
        }
    }
}
